
export default {
  name: 'CreatePortfolioInfoCard',
  props: {
    type: {
      type: String,
      default: '',
      required: true,
    },
  },
  computed: {
    cardClasses() {
      switch (this.type) {
        case 'regular':
          return 'bg-neutral-4 rounded-2xl gap-1';
        case 'league':
          return 'bg-league-purple-light rounded-xl gap-2';
        default:
          return 'bg-neutral-1 rounded-xl';
      }
    },
  },
};
